var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCellCulture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 73,
    fill: "none",
    viewBox: "0 -20 40 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FAA262",
    d: "M8 4.672h18v51a4 4 0 0 1-4 4H12a4 4 0 0 1-4-4v-51z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.005 12.099h18.052v16H8.005z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M21.042 5.672h5.015V44.17s-.057 7-.057 11.5-4.958 4-4.958 4v-54z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAA262",
    d: "M7 5h20v1H7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3295BA",
    d: "M27 5.275v.996a.29.29 0 0 1-.269.289H7.267A.289.289 0 0 1 7 6.27v-.996c0-.16.13-.29.287-.29h.079V.665c0-.133.095-.244.22-.268V.273c0-.15.123-.273.272-.273h18.284a.272.272 0 0 1 .272.273v.124c.124.025.22.136.22.268v4.32h.079a.288.288 0 0 1 .287.29z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#54BCE3",
    d: "M14.503 6.27v-.995c0-.16.129-.29.287-.29h.079V.665c0-.133.095-.244.22-.268V.273c0-.15.122-.273.272-.273H7.858a.273.273 0 0 0-.272.273v.124a.275.275 0 0 0-.22.268v4.32h-.079a.289.289 0 0 0-.287.29v.996c0 .153.118.28.268.289H14.79h-.02a.29.29 0 0 1-.267-.29z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#156988",
    d: "M8.53.503h-.465V4.97h.465V.503zM9.497.503h-.465V4.97h.465V.503zM10.465.503h-.466V4.97h.466V.503zM11.43.503h-.464V4.97h.464V.503zM12.397.503h-.465V4.97h.465V.503zM13.365.503H12.9V4.97h.466V.503zM14.33.503h-.464V4.97h.465V.503zM15.298.503h-.465V4.97h.465V.503zM16.265.503H15.8V4.97h.465V.503zM17.232.503h-.465V4.97h.465V.503zM18.2.503h-.466V4.97h.465V.503zM19.167.503h-.466V4.97h.466V.503zM20.133.503h-.465V4.97h.465V.503zM21.1.503h-.465V4.97h.466V.503zM22.068.503h-.466V4.97h.466V.503zM23.034.503h-.465V4.97h.465V.503zM24.001.503h-.466V4.97h.466V.503zM24.967.503h-.465V4.97h.465V.503zM25.934.503h-.465V4.97h.465V.503z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellCulture);
export default __webpack_public_path__ + "static/media/cellCulture.4a58d5bc152483b6781633508b5b2f78.svg";
export { ForwardRef as ReactComponent };